// BFF: ● person_claims — bffCrmPersonClaims.
export { default } from './Claims'
